import { useMemo } from 'react'

import { Filter } from '@cubejs-client/core'
import { CubeFilterDimensions, CubeOperator } from 'cube/components'
import { type AccessFiltersType } from 'cube/contexts'
import { useSelector } from 'react-redux'

import { userId } from 'modules/org/selectors'
import { userHasOrgConversationReports } from 'utils/access'

/**
 * Hook that manages access filters for cube reporting pages.
 *
 * This is primarily used in the Chats report to provide limited access (only my conversations view).
 *
 * @returns { accessFilters }
 */
const useCubeReportAccessFilters = (): AccessFiltersType => {
  const userHasLimitedReportAccess = !userHasOrgConversationReports()
  const currentUserId = useSelector(userId)

  const formatCurrentUserOnlyFilter = (userId: string): Filter => {
    return {
      member: CubeFilterDimensions.USER_PARTICIPATED_USER_ID,
      operator: CubeOperator.EQUALS,
      values: [userId],
    }
  }

  return useMemo(
    () => ({
      accessFilters: userHasLimitedReportAccess
        ? [formatCurrentUserOnlyFilter(currentUserId.toString())]
        : [],
    }),
    [currentUserId, userHasLimitedReportAccess]
  )
}

export default useCubeReportAccessFilters
